module.exports = __webpack_public_path__ + "img/card.4073b5c7.png";